// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2MCdO","title":"AfterBackImages_title__Ux7q2","images":"AfterBackImages_images__1qAgs"};